import { create, } from "zustand";
import { Pool, Trade, } from "@uniswap/v3-sdk";

import type { Token, } from "@types";


export declare type SwapState = {

	/** the token type we're swapping FROM */
	sourceToken: Token;

	/** the token type we're swapping TO */
	targetToken: Token;

	/** the amount of the token we're swapping FROM */
	amount: bigint;

	/** ?? */
	fee: number;

	/** set the token being swapped FROM */
	setTokenIn: ( token: Token ) => void;

	/** set the token being swapped TO */
	setTokenOut: ( token: Token ) => void;

	/** get a quote */
	getQuote: ( props: QuoteProps, ) => Promise<void>;

};

export const useSwapStore = create<SwapState>(( set, get, ) => ({

	sourceToken: "ETH" as Token,
	targetToken: "ETH" as Token,
	amount: BigInt(0),
	fee: 0,

	setTokenIn: ( sourceToken, ) => { set({ sourceToken, }) },

	setTokenOut: ( targetToken,  ) => { set({ targetToken, }) },

	setAmount: ( amount:bigint, ) => { set({ amount, }) },

	getQuote: async ({ tokenIn, tokenOut, amountIn, log, }) => {
		set({
			sourceToken: tokenIn || get().sourceToken,
			targetToken: tokenOut || get().targetToken,
			amount: amountIn || get().amount,
		});
		log && console.log(`gaining quote ${get().sourceToken} -> ${get().targetToken}`);
	},

}));


export declare type QuoteProps = {
	tokenIn?: Token;
	tokenOut?: Token;
	amountIn?: bigint,
	log?: boolean;
};

export declare type TradeProps = {

};
